// React
import React from "react";
// React
// CSS
import styles from "./SingleFile.module.css";
// CSS
// Models
import { I_File } from "../../../../Models/interfaces";
import { pdf_icon } from "../../../../Images/images";
import { Link } from "react-router-dom";
// Models

type SingleFileProps = {
  data: I_File;
};

const SingleFile: React.FunctionComponent<SingleFileProps> = ({
  data: {
    date,
    id,
    lesson,
    status,
    subject,
    answers: answerFileURL,
    questions: questionFileURL,
  },
}) => {
  //
  // function download(filename, text) {
  //   var element = document.createElement("a");
  //   element.setAttribute(
  //     "href",
  //     "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  //   );
  //   element.setAttribute("download", filename);

  //   element.style.display = "none";
  //   document.body.appendChild(element);

  //   element.click();

  //   document.body.removeChild(element);
  // }

  return (
    <div
      className={`${styles.singleFileItem} flex flex-row-reverse items-center justify-between w-full pb-4 last-of-type:mb-20`}
    >
      <div
        className={`${styles.right} flex flex-row-reverse items-center justify-center`}
      >
        <img src={pdf_icon} alt="" className="w-20" />
        <div className={`${styles.data} flex flex-col items-end `}>
          <span className="text-sm">{lesson}</span>
          <span className="text-xs"> {subject}</span>
          <span className="text-xs">{date}</span>
        </div>
      </div>
      <div className={`${styles.left} flex flex-col items-end pl-4 text-sm`}>
        {!!answerFileURL ? (
          <>
            <Link
              to={
                questionFileURL
                  ? questionFileURL.replace(/(http[^\s])/i, "https:").replace("::", ":")
                  : "#"
              }
              className="text-sm text-blue-600"
              download
              target="_blank"
            >
              ســـوالات
            </Link>
            <Link
              to={
                answerFileURL
                  ? answerFileURL.replace(/(http[^\s])/i, "https:").replace("::", ":")
                  : "#"
              }
              className="text-sm text-green-600 mt-2"
              download
              target="_blank"
            >
              پاسخنـامه
            </Link>
          </>
        ) : (
          <>در حال تولید</>
        )}
      </div>
    </div>
  );
};

export default SingleFile;
